import React, { useState } from 'react'
import UserImage from "../assets/user.png"
import { FaMinus } from 'react-icons/fa'
import { api } from '../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import { Link, useNavigate, useParams } from 'react-router-dom'

const ManageAdminCard = ({ user }) => {
    const [isLoading, setIsLoading] = useState(false)

    const { organization } = useParams()


    const removeAdmin = async () => {
        try {
            setIsLoading(true)
            const response = await api.patch(`/${organization}/admins`, { id:user._id })
            toast.success(response.data.message)
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            toast.error(error.response.data.message)
        }
    }

    return (
        <div className="admin-card-container">
            <Link to={`/user/${user._id}`}>
                <div className="admin-card-details">
                    <div className="admin-card-profile-image">
                        <img src={user?.profilePic ? user.profilePic.url : UserImage} alt='' />
                    </div>
                    <div className="user-profile-name">
                        <p className=''>{user?.firstname} {user?.lastname}</p>
                    </div>
                </div>
            </Link>
            <div className="admin-chat-btn" onClick={removeAdmin}>
                <FaMinus /> <p>{isLoading?"...":"Remove"}</p>
            </div>
        </div >
    )
}

export default ManageAdminCard
